import { action } from "easy-peasy";

 
const companyListing = {
    testState: "123",
    secondState: "ABC",


    // ACTIONS
    updateThisState: action((state, payload) => {
        state.testState = payload
      }),

    // THUNK
      // updateCompanyId: thunk(async actions => {
      //   const res = await fetch(
      //     "https://jsonplaceholder.typicode.com/todos?_limit=5"
      //   );
      //   const todos = await res.json();
    
      //   actions.setTodos(todos);
      // }),

      

};

 export default companyListing;